import windows10ProImg from '../assets/images/windows_10_pro.png';
import windows11ProImg from '../assets/images/windows_11_pro.png';
import windowsServer2025Img from '../assets/images/windows_server_2025.png';
import msOffice2021ProImg from '../assets/images/ms_office_2021_pro.png';
import msOffice2024ProImg from '../assets/images/ms_office_2024_pro.png';
import msOffice2024HbImg from '../assets/images/ms_office_2024_hb.png';
import categoryWindowsImg from '../assets/images/category_windows.jpg';
import categoryMsOfficeImg from '../assets/images/category_msoffice.jpg';
import categoryServerImg from '../assets/images/category_server.jpg';
import categoryAdobeImg from '../assets/images/category_adobe.jpg';
import categoryOthersImg from '../assets/images/category_others.jpg';
import categoryComboImg from '../assets/images/category_combo.jpg';

export const products = [
  // ==========================================
  // WINDOWS 7
  // ==========================================
  {
    id: 101,
    name: 'Windows 7 Professional Retail Key',
    price: 399,
    oldPrice: 1999,
    image: windows10ProImg,
    featuredImage: windows10ProImg,
    slug: 'windows-7-professional-retail',
    ogUrl: 'windows-7-professional-retail',
    rating: 4.7,
    reviews: 84,
    reviewsCount: 84,
    badge: 'Lifetime Validity',
    weight: 'Retail Key',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-7',
    tags: ['windows', 'windows-7', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Genuine Microsoft Windows 7 Professional 32/64-Bit license key. Ideal for legacy systems, industrial PCs, and specialized software requiring Windows 7 compatibility. Delivers permanent lifetime activation.',
    features: [
      'Official Microsoft Windows 7 Pro Key',
      'Supports both 32-bit & 64-bit editions',
      'Lifetime Permanent Activation',
      'Aero UI and Windows XP Mode support',
      'Instant Email & WhatsApp delivery'
    ]
  },
  {
    id: 102,
    name: 'Windows 7 Ultimate Retail Key',
    price: 449,
    oldPrice: 2299,
    image: windows10ProImg,
    featuredImage: windows10ProImg,
    slug: 'windows-7-ultimate-retail',
    ogUrl: 'windows-7-ultimate-retail',
    rating: 4.8,
    reviews: 62,
    reviewsCount: 62,
    badge: 'Lifetime Validity',
    weight: 'Retail Key',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-7',
    tags: ['windows', 'windows-7', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'The most comprehensive edition of Windows 7 with BitLocker data encryption, multi-language packs (35 languages), and full enterprise features.',
    features: [
      'Windows 7 Ultimate 32/64-Bit Activation',
      'BitLocker Drive Encryption',
      'Switch between 35 languages on the fly',
      'Lifetime Validity'
    ]
  },

  // ==========================================
  // WINDOWS 8 & 8.1
  // ==========================================
  {
    id: 103,
    name: 'Windows 8 Pro Digital License',
    price: 399,
    oldPrice: 1999,
    image: windows10ProImg,
    featuredImage: windows10ProImg,
    slug: 'windows-8-pro-digital',
    ogUrl: 'windows-8-pro-digital',
    rating: 4.6,
    reviews: 42,
    reviewsCount: 42,
    badge: 'Lifetime Validity',
    weight: 'Retail Key',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-8',
    tags: ['windows', 'windows-8', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Genuine Windows 8 Pro product key for 1 PC with permanent activation and enhanced touch & desktop multitasking.',
    features: [
      'Official Windows 8 Pro Key',
      'Lifetime Activation',
      'Storage Spaces & BitLocker',
      'Instant Digital Delivery'
    ]
  },
  {
    id: 104,
    name: 'Windows 8.1 Pro Retail Activation Key',
    price: 449,
    oldPrice: 2499,
    image: windows10ProImg,
    featuredImage: windows10ProImg,
    slug: 'windows-8-1-pro-retail',
    ogUrl: 'windows-8-1-pro-retail',
    rating: 4.7,
    reviews: 78,
    reviewsCount: 78,
    badge: 'Lifetime Validity',
    weight: 'Retail Key',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-8-1',
    tags: ['windows', 'windows-8-1', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Official Windows 8.1 Pro Retail key. Includes the Start button return, boot-to-desktop, enhanced search, and enterprise domain join.',
    features: [
      'Windows 8.1 Pro 32/64-Bit Key',
      'Domain Join & Remote Desktop Host',
      'BitLocker & Client Hyper-V',
      'Lifetime Activation'
    ]
  },

  // ==========================================
  // WINDOWS 10
  // ==========================================
  {
    id: 105,
    name: 'Windows 10 Pro Retail Key',
    price: 499,
    oldPrice: 1999,
    image: windows10ProImg,
    featuredImage: windows10ProImg,
    slug: 'windows-10-pro-retail',
    ogUrl: 'windows-10-pro-retail',
    rating: 4.8,
    reviews: 342,
    reviewsCount: 342,
    badge: 'Lifetime Validity',
    weight: 'Retail License',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-10',
    tags: ['windows', 'windows-10', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Get the genuine Microsoft Windows 10 Pro Retail license key. Full lifetime activation with official updates, transferable to another PC, and linkable to your Microsoft Account.',
    features: [
      'Genuine Retail License Key',
      'Lifetime Validity (No Subscriptions)',
      'Transferable to another PC',
      'BitLocker Encryption & Remote Desktop',
      'Free technical support'
    ]
  },
  {
    id: 106,
    name: 'Windows 10 Pro OEM Key',
    price: 599,
    oldPrice: 2499,
    image: windows10ProImg,
    featuredImage: windows10ProImg,
    slug: 'windows-10-pro-oem',
    ogUrl: 'windows-10-pro-oem',
    rating: 4.7,
    reviews: 188,
    reviewsCount: 188,
    badge: 'Lifetime Validity',
    weight: 'OEM License',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-10',
    tags: ['windows', 'windows-10', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Genuine Microsoft Windows 10 Pro OEM product key. Binds permanently to your motherboard for seamless lifetime OS activation.',
    features: [
      'Official Microsoft OEM Key',
      'Lifetime Activation on 1 Motherboard',
      'Cost-effective for system upgrades',
      'Official ISO download assistance'
    ]
  },
  {
    id: 107,
    name: 'Windows 10 Home Retail Key',
    price: 449,
    oldPrice: 1799,
    image: windows10ProImg,
    featuredImage: windows10ProImg,
    slug: 'windows-10-home-retail',
    ogUrl: 'windows-10-home-retail',
    rating: 4.8,
    reviews: 110,
    reviewsCount: 110,
    badge: 'Lifetime Validity',
    weight: 'Retail License',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-10',
    tags: ['windows', 'windows-10', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Genuine Microsoft Windows 10 Home digital product key. Ideal for personal use, gaming, and day-to-day computing.',
    features: [
      'Official Windows 10 Home Key',
      'Windows Hello biometric login',
      'DirectX 12 gaming support',
      'Lifetime permanent activation'
    ]
  },

  // ==========================================
  // WINDOWS 11
  // ==========================================
  {
    id: 108,
    name: 'Windows 11 Pro Retail Key',
    price: 499,
    oldPrice: 2499,
    image: windows11ProImg,
    featuredImage: windows11ProImg,
    slug: 'windows-11-pro-retail',
    ogUrl: 'windows-11-pro-retail',
    rating: 4.9,
    reviews: 415,
    reviewsCount: 415,
    badge: 'Lifetime Validity',
    weight: 'Retail License',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-11',
    tags: ['windows', 'windows-11', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Upgrade your PC to Microsoft\'s latest and most advanced OS with a Windows 11 Pro Retail product key. Features Auto HDR, TPM 2.0 security, Snap layouts, and Microsoft Account linking.',
    features: [
      'Genuine Windows 11 Pro Retail Key',
      'TPM 2.0 and Secure Boot compatible',
      'Transferable to new hardware',
      'Snap layouts & Virtual Desktops',
      'Instant Email & WhatsApp delivery'
    ]
  },
  {
    id: 109,
    name: 'Windows 11 Pro OEM Key',
    price: 599,
    oldPrice: 2999,
    image: windows11ProImg,
    featuredImage: windows11ProImg,
    slug: 'windows-11-pro-oem',
    ogUrl: 'windows-11-pro-oem',
    rating: 4.8,
    reviews: 160,
    reviewsCount: 160,
    badge: 'Lifetime Validity',
    weight: 'OEM License',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-11',
    tags: ['windows', 'windows-11', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Official Windows 11 Pro OEM license key bound directly to your motherboard with lifetime validity and security updates.',
    features: [
      'Official Microsoft Windows 11 Pro OEM Key',
      'Permanent activation tied to hardware ID',
      'BitLocker & Windows Defender included',
      'High-performance gaming optimization'
    ]
  },
  {
    id: 110,
    name: 'Windows 11 Home Retail Key',
    price: 449,
    oldPrice: 1999,
    image: windows11ProImg,
    featuredImage: windows11ProImg,
    slug: 'windows-11-home-retail',
    ogUrl: 'windows-11-home-retail',
    rating: 4.8,
    reviews: 135,
    reviewsCount: 135,
    badge: 'Lifetime Validity',
    weight: 'Retail License',
    category_id: 1,
    category: 'Windows',
    parent_category: 'microsoft',
    subcategory: 'windows-11',
    tags: ['windows', 'windows-11', 'microsoft', 'os'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Official Windows 11 Home Edition key with sleek rounded design, widgets, and seamless gaming performance.',
    features: [
      'Genuine Windows 11 Home Digital Key',
      'Auto HDR & DirectStorage',
      'Clean modern taskbar & Microsoft Store',
      'Lifetime license'
    ]
  },

  // ==========================================
  // MS OFFICE
  // ==========================================
  {
    id: 201,
    name: 'MS Office 2024 Pro Plus Key',
    price: 599,
    oldPrice: 4999,
    image: msOffice2024ProImg,
    featuredImage: msOffice2024ProImg,
    slug: 'ms-office-2024-pro-plus',
    ogUrl: 'ms-office-2024-pro-plus',
    rating: 5.0,
    reviews: 182,
    reviewsCount: 182,
    badge: 'Lifetime Validity',
    weight: 'Office Suite',
    category_id: 2,
    category: 'MS Office',
    parent_category: 'microsoft',
    subcategory: 'ms-office',
    tags: ['ms-office', 'office', 'microsoft', 'word', 'excel'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Get the latest Microsoft Office 2024 Professional Plus lifetime license. Word, Excel, PowerPoint, Outlook, OneNote, and Access on Windows with no recurring subscription fees.',
    features: [
      'Genuine Microsoft Office 2024 Pro Plus Key',
      'Lifetime activation on 1 PC',
      'Word, Excel, PowerPoint, Outlook, Access',
      'High-speed calculation engine in Excel 2024',
      'Instant digital key delivery'
    ]
  },
  {
    id: 202,
    name: 'MS Office 2024 Home & Business (Mac/PC)',
    price: 1499,
    oldPrice: 5999,
    image: msOffice2024HbImg,
    featuredImage: msOffice2024HbImg,
    slug: 'ms-office-2024-home-business',
    ogUrl: 'ms-office-2024-home-business',
    rating: 4.9,
    reviews: 96,
    reviewsCount: 96,
    badge: 'Lifetime Validity',
    weight: 'Office Suite',
    category_id: 2,
    category: 'MS Office',
    parent_category: 'microsoft',
    subcategory: 'ms-office',
    tags: ['ms-office', 'office', 'microsoft', 'mac'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Genuine Microsoft Office 2024 Home & Business account-bind key. Works on either Windows PC or Apple Mac with lifetime license.',
    features: [
      'Binds directly to your Microsoft Account (setup.office.com)',
      'Compatible with Windows 10/11 & macOS',
      'Word, Excel, PowerPoint, Outlook, OneNote',
      'Transferable across devices'
    ]
  },
  {
    id: 203,
    name: 'MS Office 2021 Pro Plus Key',
    price: 499,
    oldPrice: 3999,
    image: msOffice2021ProImg,
    featuredImage: msOffice2021ProImg,
    slug: 'ms-office-2021-pro-plus',
    ogUrl: 'ms-office-2021-pro-plus',
    rating: 4.8,
    reviews: 520,
    reviewsCount: 520,
    badge: 'Lifetime Validity',
    weight: 'Office Suite',
    category_id: 2,
    category: 'MS Office',
    parent_category: 'microsoft',
    subcategory: 'ms-office',
    tags: ['ms-office', 'office', 'microsoft', 'word', 'excel'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Genuine Microsoft Office 2021 Professional Plus digital key. The classic productivity suite for work and business.',
    features: [
      'Official Professional Plus license key',
      'Lifetime use on 1 Windows PC (one-time buy)',
      'Word, Excel, PPT, Outlook, Access, Publisher',
      'XLOOKUP and dynamic arrays in Excel'
    ]
  },
  {
    id: 204,
    name: 'MS Office 2019 Pro Plus Key',
    price: 399,
    oldPrice: 2999,
    image: msOffice2021ProImg,
    featuredImage: msOffice2021ProImg,
    slug: 'ms-office-2019-pro-plus',
    ogUrl: 'ms-office-2019-pro-plus',
    rating: 4.7,
    reviews: 210,
    reviewsCount: 210,
    badge: 'Lifetime Validity',
    weight: 'Office Suite',
    category_id: 2,
    category: 'MS Office',
    parent_category: 'microsoft',
    subcategory: 'ms-office',
    tags: ['ms-office', 'office', 'microsoft'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Affordable, rock-solid productivity suite featuring Word, Excel, PowerPoint, and Outlook for Windows 10 & 11.',
    features: [
      'Office 2019 Pro Plus Lifetime License',
      'Stable performance on all PC configurations',
      'Includes full office suite',
      'Permanent activation'
    ]
  },

  // ==========================================
  // SERVERS
  // ==========================================
  {
    id: 301,
    name: 'Windows Server 2025 Standard Key',
    price: 1799,
    oldPrice: 7999,
    image: windowsServer2025Img,
    featuredImage: windowsServer2025Img,
    slug: 'windows-server-2025-standard',
    ogUrl: 'windows-server-2025-standard',
    rating: 4.9,
    reviews: 45,
    reviewsCount: 45,
    badge: 'Lifetime Validity',
    weight: 'Server License',
    category_id: 3,
    category: 'Servers',
    parent_category: 'microsoft',
    subcategory: 'servers',
    tags: ['servers', 'server', 'windows-server', 'microsoft'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Genuine Microsoft Windows Server 2025 Standard digital license. Built for hybrid cloud, Hyper-V nested virtualization, and multi-layer enterprise security.',
    features: [
      'Windows Server 2025 Standard Activation Key',
      'Advanced multi-layer hardware security',
      'Hybrid Cloud integration with Azure Arc',
      'Lifetime Server Activation'
    ]
  },
  {
    id: 302,
    name: 'Windows Server 2025 Datacenter Key',
    price: 2999,
    oldPrice: 12999,
    image: windowsServer2025Img,
    featuredImage: windowsServer2025Img,
    slug: 'windows-server-2025-datacenter',
    ogUrl: 'windows-server-2025-datacenter',
    rating: 5.0,
    reviews: 28,
    reviewsCount: 28,
    badge: 'Lifetime Validity',
    weight: 'Server License',
    category_id: 3,
    category: 'Servers',
    parent_category: 'microsoft',
    subcategory: 'servers',
    tags: ['servers', 'server', 'windows-server', 'microsoft'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Unlimited virtualization and software-defined storage for high-density enterprise datacenter deployments.',
    features: [
      'Unlimited Hyper-V Virtual Machines',
      'Storage Spaces Direct (S2D)',
      'Shielded Virtual Machines & SDN',
      'Lifetime License'
    ]
  },
  {
    id: 303,
    name: 'Windows Server 2022 Standard Key',
    price: 1499,
    oldPrice: 6999,
    image: windowsServer2025Img,
    featuredImage: windowsServer2025Img,
    slug: 'windows-server-2022-standard',
    ogUrl: 'windows-server-2022-standard',
    rating: 4.8,
    reviews: 94,
    reviewsCount: 94,
    badge: 'Lifetime Validity',
    weight: 'Server License',
    category_id: 3,
    category: 'Servers',
    parent_category: 'microsoft',
    subcategory: 'servers',
    tags: ['servers', 'server', 'windows-server', 'microsoft'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Most popular server OS with Secured-Core Server capabilities and enterprise hybrid cloud management.',
    features: [
      'Windows Server 2022 Standard 16 Core License',
      'Secured-Core Server protection',
      'HTTPS & TLS 1.3 enabled by default',
      'Lifetime activation'
    ]
  },

  // ==========================================
  // SQL SERVER
  // ==========================================
  {
    id: 401,
    name: 'Microsoft SQL Server 2022 Standard Key',
    price: 2499,
    oldPrice: 9999,
    image: categoryServerImg,
    featuredImage: categoryServerImg,
    slug: 'microsoft-sql-server-2022-standard',
    ogUrl: 'microsoft-sql-server-2022-standard',
    rating: 4.9,
    reviews: 38,
    reviewsCount: 38,
    badge: 'Enterprise License',
    weight: 'Database License',
    category_id: 4,
    category: 'SQL Server',
    parent_category: 'microsoft',
    subcategory: 'sql-server',
    tags: ['sql-server', 'sql', 'database', 'microsoft', 'servers'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Microsoft SQL Server 2022 Standard Edition digital product key. Industry-leading database management, Azure Synapse Link, and data virtualization.',
    features: [
      'Official SQL Server 2022 Standard Key',
      'Seamless Azure Synapse Link integration',
      'Built-in query intelligence',
      'Permanent database server activation'
    ]
  },
  {
    id: 402,
    name: 'Microsoft SQL Server 2019 Standard Key',
    price: 1999,
    oldPrice: 8499,
    image: categoryServerImg,
    featuredImage: categoryServerImg,
    slug: 'microsoft-sql-server-2019-standard',
    ogUrl: 'microsoft-sql-server-2019-standard',
    rating: 4.8,
    reviews: 52,
    reviewsCount: 52,
    badge: 'Enterprise License',
    weight: 'Database License',
    category_id: 4,
    category: 'SQL Server',
    parent_category: 'microsoft',
    subcategory: 'sql-server',
    tags: ['sql-server', 'sql', 'database', 'microsoft'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Reliable, enterprise relational database software with Big Data Clusters and Intelligent Database capabilities.',
    features: [
      'SQL Server 2019 Standard Key',
      'PolyBase data virtualization',
      'In-memory database performance',
      'Lifetime validity'
    ]
  },

  // ==========================================
  // VISUAL STUDIO
  // ==========================================
  {
    id: 501,
    name: 'Visual Studio 2022 Professional License',
    price: 1199,
    oldPrice: 4999,
    image: categoryMsOfficeImg,
    featuredImage: categoryMsOfficeImg,
    slug: 'visual-studio-2022-professional',
    ogUrl: 'visual-studio-2022-professional',
    rating: 4.9,
    reviews: 67,
    reviewsCount: 67,
    badge: 'Developer License',
    weight: 'Developer Key',
    category_id: 5,
    category: 'Visual Studio',
    parent_category: 'microsoft',
    subcategory: 'visual-studio',
    tags: ['visual-studio', 'developer', 'microsoft', 'coding'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Comprehensive 64-bit IDE for professional developers. Build modern cloud, web, desktop, and mobile applications with IntelliCode AI assistance.',
    features: [
      'Visual Studio 2022 Pro Activation Key',
      'Full 64-bit IDE architecture',
      'IntelliCode AI-assisted coding',
      '.NET 8 / C++ / Python / JS support',
      'Lifetime developer activation'
    ]
  },
  {
    id: 502,
    name: 'Visual Studio 2022 Enterprise License',
    price: 2499,
    oldPrice: 8999,
    image: categoryMsOfficeImg,
    featuredImage: categoryMsOfficeImg,
    slug: 'visual-studio-2022-enterprise',
    ogUrl: 'visual-studio-2022-enterprise',
    rating: 5.0,
    reviews: 31,
    reviewsCount: 31,
    badge: 'Enterprise License',
    weight: 'Developer Key',
    category_id: 5,
    category: 'Visual Studio',
    parent_category: 'microsoft',
    subcategory: 'visual-studio',
    tags: ['visual-studio', 'developer', 'microsoft'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'End-to-end solution for large software teams with advanced profiling, IntelliTrace debugging, and automated testing architecture.',
    features: [
      'Visual Studio 2022 Enterprise Key',
      'Live Unit Testing & CodeLens',
      'IntelliTrace real-time debugging',
      'Lifetime activation'
    ]
  },

  // ==========================================
  // ADOBE
  // ==========================================
  {
    id: 601,
    name: 'Adobe Acrobat Pro DC Lifetime License',
    price: 1299,
    oldPrice: 4999,
    image: categoryAdobeImg,
    featuredImage: categoryAdobeImg,
    slug: 'adobe-acrobat-pro-dc',
    ogUrl: 'adobe-acrobat-pro-dc',
    rating: 4.9,
    reviews: 210,
    reviewsCount: 210,
    badge: 'Lifetime License',
    weight: 'Productivity Suite',
    category_id: 6,
    category: 'Adobe',
    parent_category: 'adobe',
    subcategory: 'adobe',
    tags: ['adobe', 'acrobat', 'pdf', 'creative'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'The world\'s #1 PDF solution. Edit, convert, sign, protect, and manage PDF documents on Windows & Mac with full lifetime activation.',
    features: [
      'Adobe Acrobat Pro DC Activation',
      'Full PDF Editing & Optical Character Recognition (OCR)',
      'Digital E-Signatures & Document Protection',
      'Convert to/from Word, Excel, PowerPoint',
      'Lifetime activation'
    ]
  },
  {
    id: 602,
    name: 'Adobe Photoshop 2024 Full License',
    price: 1499,
    oldPrice: 5999,
    image: categoryAdobeImg,
    featuredImage: categoryAdobeImg,
    slug: 'adobe-photoshop-2024',
    ogUrl: 'adobe-photoshop-2024',
    rating: 4.9,
    reviews: 320,
    reviewsCount: 320,
    badge: 'Lifetime License',
    weight: 'Design Suite',
    category_id: 6,
    category: 'Adobe',
    parent_category: 'adobe',
    subcategory: 'adobe',
    tags: ['adobe', 'photoshop', 'design', 'photo'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Industry standard photo editing and graphic design software with AI generative fill, neural filters, and precision retouching.',
    features: [
      'Full Version Photoshop 2024 License',
      'Generative Fill & AI Neural Filters',
      'Raw camera processing & unlimited layers',
      'Permanent activation with setup guide'
    ]
  },
  {
    id: 603,
    name: 'Adobe Illustrator 2024 Vector Suite',
    price: 1499,
    oldPrice: 5999,
    image: categoryAdobeImg,
    featuredImage: categoryAdobeImg,
    slug: 'adobe-illustrator-2024',
    ogUrl: 'adobe-illustrator-2024',
    rating: 4.8,
    reviews: 180,
    reviewsCount: 180,
    badge: 'Lifetime License',
    weight: 'Vector Design',
    category_id: 6,
    category: 'Adobe',
    parent_category: 'adobe',
    subcategory: 'adobe',
    tags: ['adobe', 'illustrator', 'vector', 'design'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Precision vector graphics and illustration software used for logos, icons, typography, and complex artwork.',
    features: [
      'Full Adobe Illustrator 2024 License',
      'Vector generative AI tools',
      'Typography & typography tools',
      'Lifetime activation'
    ]
  },
  {
    id: 604,
    name: 'Adobe Premiere Pro 2024 Video Suite',
    price: 1599,
    oldPrice: 6499,
    image: categoryAdobeImg,
    featuredImage: categoryAdobeImg,
    slug: 'adobe-premiere-pro-2024',
    ogUrl: 'adobe-premiere-pro-2024',
    rating: 4.9,
    reviews: 140,
    reviewsCount: 140,
    badge: 'Lifetime License',
    weight: 'Video Editing',
    category_id: 6,
    category: 'Adobe',
    parent_category: 'adobe',
    subcategory: 'adobe',
    tags: ['adobe', 'premiere', 'video', 'editing'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Leading video editing software for film, TV, and the web. Text-based editing, AI speech enhancement, and 8K color grading.',
    features: [
      'Full Premiere Pro 2024 License',
      'AI Text-based editing and captioning',
      'Lumetri Color grading & multi-camera editing',
      'Lifetime activation'
    ]
  },

  // ==========================================
  // OTHERS: AUTODESK, CORELDRAW, TALLY
  // ==========================================
  {
    id: 701,
    name: 'Autodesk AutoCAD 2024 (1 Year License)',
    price: 2499,
    oldPrice: 8999,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'autodesk-autocad-2024',
    ogUrl: 'autodesk-autocad-2024',
    rating: 4.9,
    reviews: 95,
    reviewsCount: 95,
    badge: 'Commercial License',
    weight: '1 Year License',
    category_id: 7,
    category: 'Others',
    parent_category: 'others',
    subcategory: 'auto-desk',
    tags: ['others', 'auto-desk', 'autodesk', 'autocad', 'cad', 'engineering'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Industry-standard 2D and 3D CAD design software with specialized toolsets for architecture, mechanical, and electrical engineering.',
    features: [
      'Official Autodesk AutoCAD 2024 License',
      '2D drafting and 3D solid modeling',
      'Autodesk Account Activation',
      'Includes specialized architecture toolset'
    ]
  },
  {
    id: 702,
    name: 'Autodesk Revit 2024 BIM License',
    price: 2999,
    oldPrice: 9999,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'autodesk-revit-2024',
    ogUrl: 'autodesk-revit-2024',
    rating: 4.8,
    reviews: 42,
    reviewsCount: 42,
    badge: 'Commercial License',
    weight: '1 Year License',
    category_id: 7,
    category: 'Others',
    parent_category: 'others',
    subcategory: 'auto-desk',
    tags: ['others', 'auto-desk', 'autodesk', 'revit', 'bim'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Building Information Modeling (BIM) software for architectural design, MEP engineering, structural engineering, and construction.',
    features: [
      'Official Autodesk Revit 2024 License',
      'Parametric components & 3D visualization',
      'Multidisciplinary coordination',
      '1 Year Commercial Subscription'
    ]
  },
  {
    id: 706,
    name: 'Autodesk 3ds Max 2024 3D Modeling Suite',
    price: 2799,
    oldPrice: 9499,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'autodesk-3ds-max-2024',
    ogUrl: 'autodesk-3ds-max-2024',
    rating: 4.9,
    reviews: 58,
    reviewsCount: 58,
    badge: 'Commercial License',
    weight: '1 Year License',
    category_id: 7,
    category: 'Others',
    parent_category: 'others',
    subcategory: 'auto-desk',
    tags: ['others', 'auto-desk', 'autodesk', '3ds max', '3d', 'modeling'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Professional 3D modeling, rendering, and animation software for game design, visual effects, and architectural visualization.',
    features: [
      'Official Autodesk 3ds Max 2024 License',
      'Arnold renderer integration',
      'Advanced polygon and texture modeling',
      '1 Year Commercial License'
    ]
  },
  {
    id: 707,
    name: 'Autodesk Maya 2024 Animation & VFX',
    price: 2899,
    oldPrice: 9999,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'autodesk-maya-2024',
    ogUrl: 'autodesk-maya-2024',
    rating: 4.8,
    reviews: 36,
    reviewsCount: 36,
    badge: 'Commercial License',
    weight: '1 Year License',
    category_id: 7,
    category: 'Others',
    parent_category: 'others',
    subcategory: 'auto-desk',
    tags: ['others', 'auto-desk', 'autodesk', 'maya', 'vfx', 'animation'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Industry-standard 3D animation, motion graphics, and visual effects software used by top film and gaming studios worldwide.',
    features: [
      'Autodesk Maya 2024 Commercial License',
      'Bifrost procedural effects & physics simulation',
      'Character rigging and keyframe animation',
      '1 Year Commercial Subscription'
    ]
  },
  {
    id: 708,
    name: 'Autodesk Civil 3D 2024 Infrastructure',
    price: 2999,
    oldPrice: 10499,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'autodesk-civil-3d-2024',
    ogUrl: 'autodesk-civil-3d-2024',
    rating: 4.9,
    reviews: 29,
    reviewsCount: 29,
    badge: 'Commercial License',
    weight: '1 Year License',
    category_id: 7,
    category: 'Others',
    parent_category: 'others',
    subcategory: 'auto-desk',
    tags: ['others', 'auto-desk', 'autodesk', 'civil 3d', 'engineering', 'infrastructure'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Civil engineering design and documentation software for infrastructure projects, transportation, and land development.',
    features: [
      'Autodesk Civil 3D 2024 Activation',
      'Corridor modeling & dynamic surfaces',
      'Storm & sanitary analysis tools',
      '1 Year Commercial License'
    ]
  },
  {
    id: 703,
    name: 'CorelDRAW Graphics Suite 2024 Lifetime',
    price: 1199,
    oldPrice: 4999,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'coreldraw-graphics-suite-2024',
    ogUrl: 'coreldraw-graphics-suite-2024',
    rating: 4.8,
    reviews: 165,
    reviewsCount: 165,
    badge: 'Lifetime License',
    weight: 'Graphics Suite',
    category_id: 7,
    category: 'Others',
    parent_category: 'others',
    subcategory: 'coreldraw',
    tags: ['others', 'coreldraw', 'graphics', 'vector', 'design'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Complete graphic design software suite for vector illustration, layout, photo editing, and typography on Windows PC.',
    features: [
      'CorelDRAW Graphics Suite 2024 Perpetual Key',
      'Includes Corel PHOTO-PAINT & Corel Font Manager',
      'Vector illustration & multi-page layout',
      'Lifetime activation (one-time purchase)'
    ]
  },
  {
    id: 704,
    name: 'Tally Prime Silver (Single-User Perpetual)',
    price: 3499,
    oldPrice: 18000,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'tally-prime-silver',
    ogUrl: 'tally-prime-silver',
    rating: 4.9,
    reviews: 240,
    reviewsCount: 240,
    badge: 'Perpetual License',
    weight: 'Single User Key',
    category_id: 7,
    category: 'Others',
    parent_category: 'others',
    subcategory: 'tally',
    tags: ['others', 'tally', 'accounting', 'gst', 'erp'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'India\'s most trusted business management and GST accounting software. Manage billing, inventory, banking, and tax compliance with ease.',
    features: [
      'Tally Prime Silver Perpetual Activation',
      'GST Billing, E-Way Bill & E-Invoicing',
      'Complete Inventory & Banking Management',
      'Lifetime license for 1 PC'
    ]
  },
  {
    id: 705,
    name: 'Tally Prime Gold (Multi-User Perpetual)',
    price: 6999,
    oldPrice: 36000,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'tally-prime-gold',
    ogUrl: 'tally-prime-gold',
    rating: 5.0,
    reviews: 130,
    reviewsCount: 130,
    badge: 'Multi-User License',
    weight: 'Multi-User LAN',
    category_id: 7,
    category: 'Others',
    parent_category: 'others',
    subcategory: 'tally',
    tags: ['others', 'tally', 'accounting', 'gst', 'erp'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Multi-user LAN license for Tally Prime. Connect unlimited PCs on your local network simultaneously for fast enterprise accounting.',
    features: [
      'Tally Prime Gold Multi-User Perpetual License',
      'Unlimited simultaneous network users',
      'Real-time multi-branch synchronization',
      'Lifetime activation'
    ]
  },

  // ==========================================
  // ANTIVIRUS & CYBERSECURITY
  // ==========================================
  {
    id: 720,
    name: 'Quick Heal Total Security 2024 (1 PC / 1 Year)',
    price: 499,
    oldPrice: 1899,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'quick-heal-total-security-1-year',
    ogUrl: 'quick-heal-total-security-1-year',
    rating: 4.9,
    reviews: 310,
    reviewsCount: 310,
    badge: '1 Year Protection',
    weight: '1 PC / 1 Year',
    category_id: 9,
    category: 'Antivirus',
    parent_category: 'others',
    subcategory: 'antivirus',
    brand: 'Quick Heal',
    tags: ['others', 'antivirus', 'quick heal', 'security', 'cybersecurity'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Complete real-time protection against ransomware, malware, phishing attacks, and malicious websites. Includes Safe Banking and Parental Control features.',
    features: [
      'Official Quick Heal Total Security 1 Year Key',
      'Advanced Ransomware & Anti-Malware Protection',
      'Safe Banking with secure browser environment',
      'Instant digital key & activation guide via Email'
    ]
  },
  {
    id: 721,
    name: 'Quick Heal Total Security 2024 (1 PC / 3 Years)',
    price: 899,
    oldPrice: 3499,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'quick-heal-total-security-3-years',
    ogUrl: 'quick-heal-total-security-3-years',
    rating: 5.0,
    reviews: 215,
    reviewsCount: 215,
    badge: '3 Years Protection',
    weight: '1 PC / 3 Years',
    category_id: 9,
    category: 'Antivirus',
    parent_category: 'others',
    subcategory: 'antivirus',
    brand: 'Quick Heal',
    tags: ['others', 'antivirus', 'quick heal', 'security', 'cybersecurity'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Long-term 3-year uninterrupted cybersecurity shield for your computer. Save big with 36 months of automated security definitions and cloud protection.',
    features: [
      'Quick Heal 3-Year License Key',
      'Multi-layered AI-driven Threat Protection',
      'Zero-Day Vulnerability Shield',
      '24/7 Official Customer Support'
    ]
  },
  {
    id: 722,
    name: 'Kaspersky Total Security 2024 (1 PC / 1 Year)',
    price: 599,
    oldPrice: 2199,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'kaspersky-total-security-1-year',
    ogUrl: 'kaspersky-total-security-1-year',
    rating: 4.9,
    reviews: 180,
    reviewsCount: 180,
    badge: 'Top Rated Security',
    weight: '1 PC / 1 Year',
    category_id: 9,
    category: 'Antivirus',
    parent_category: 'others',
    subcategory: 'antivirus',
    brand: 'Kaspersky',
    tags: ['others', 'antivirus', 'kaspersky', 'security', 'cybersecurity'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Award-winning antivirus and cybersecurity package. Includes unlimited VPN, Password Manager, and real-time payment defense.',
    features: [
      'Official Kaspersky Total Security Activation Key',
      'Triple-layer protection engine for PC',
      'Free VPN & Privacy Shield',
      'Lifetime technical support'
    ]
  },
  {
    id: 723,
    name: 'Norton 360 Deluxe (3 Devices / 1 Year)',
    price: 799,
    oldPrice: 2999,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'norton-360-deluxe-3-devices',
    ogUrl: 'norton-360-deluxe-3-devices',
    rating: 4.8,
    reviews: 145,
    reviewsCount: 145,
    badge: 'Multi-Device (3 PCs)',
    weight: '3 Devices / 1 Year',
    category_id: 9,
    category: 'Antivirus',
    parent_category: 'others',
    subcategory: 'antivirus',
    brand: 'Norton',
    tags: ['others', 'antivirus', 'norton', 'security', 'cybersecurity'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Comprehensive digital defense for up to 3 PCs, Macs, or smartphones. Dark Web Monitoring, Secure VPN, and 50GB Cloud Backup included.',
    features: [
      'Norton 360 Deluxe 3-Device Subscription',
      'Real-time Spyware & Virus protection',
      'Smart Firewall & Password Manager',
      'Instant Email & WhatsApp delivery'
    ]
  },
  {
    id: 724,
    name: 'McAfee Total Protection (1 PC / 3 Years)',
    price: 699,
    oldPrice: 2499,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'mcafee-total-protection-3-years',
    ogUrl: 'mcafee-total-protection-3-years',
    rating: 4.8,
    reviews: 120,
    reviewsCount: 120,
    badge: '3 Years Protection',
    weight: '1 PC / 3 Years',
    category_id: 9,
    category: 'Antivirus',
    parent_category: 'others',
    subcategory: 'antivirus',
    brand: 'McAfee',
    tags: ['others', 'antivirus', 'mcafee', 'security', 'cybersecurity'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'All-in-one protection across identity, privacy, and malware defense with automated vulnerability scanner and file shredder.',
    features: [
      'McAfee Total Protection 3-Year Key',
      'Award-winning anti-virus scanner',
      'Identity Theft Protection & WebAdvisor',
      'Instant digital delivery'
    ]
  },
  {
    id: 725,
    name: 'Bitdefender Total Security (1 PC / 1 Year)',
    price: 649,
    oldPrice: 2399,
    image: categoryOthersImg,
    featuredImage: categoryOthersImg,
    slug: 'bitdefender-total-security-1-year',
    ogUrl: 'bitdefender-total-security-1-year',
    rating: 4.9,
    reviews: 98,
    reviewsCount: 98,
    badge: 'Ultimate Security',
    weight: '1 PC / 1 Year',
    category_id: 9,
    category: 'Antivirus',
    parent_category: 'others',
    subcategory: 'antivirus',
    brand: 'Bitdefender',
    tags: ['others', 'antivirus', 'bitdefender', 'security', 'cybersecurity'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Best protection against e-threats with zero system slowdown. Multi-layer ransomware defense and microphone/webcam security.',
    features: [
      'Bitdefender Total Security 2024 Key',
      'Complete data protection & anti-phishing',
      'Ultra-lightweight performance engine',
      'Lifetime activation assistance'
    ]
  },

  // ==========================================
  // COMBO DEALS
  // ==========================================
  {
    id: 801,
    name: 'Windows 11 Pro + MS Office 2024 Pro Plus Mega Combo',
    price: 999,
    oldPrice: 6999,
    image: categoryComboImg,
    featuredImage: categoryComboImg,
    slug: 'windows-11-pro-office-2024-combo',
    ogUrl: 'windows-11-pro-office-2024-combo',
    rating: 5.0,
    reviews: 450,
    reviewsCount: 450,
    badge: 'Best Value Bundle',
    weight: 'Mega Combo Pack',
    category_id: 8,
    category: 'Combo',
    parent_category: 'combo',
    subcategory: 'combo',
    tags: ['combo', 'windows', 'windows-11', 'ms-office', 'office', 'deal'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'The ultimate all-in-one upgrade combo! Get genuine Windows 11 Pro Retail Key + Microsoft Office 2024 Professional Plus at a special discounted bundle price. Lifetime activation for both products.',
    features: [
      '1x Windows 11 Pro Retail Lifetime Key',
      '1x MS Office 2024 Pro Plus Lifetime Key',
      'Instant delivery via Email & WhatsApp',
      'Step-by-step activation instructions included',
      'Save over 85% compared to individual retail licenses'
    ]
  },
  {
    id: 802,
    name: 'Windows 10 Pro + MS Office 2021 Pro Plus Essential Combo',
    price: 849,
    oldPrice: 5999,
    image: categoryComboImg,
    featuredImage: categoryComboImg,
    slug: 'windows-10-pro-office-2021-combo',
    ogUrl: 'windows-10-pro-office-2021-combo',
    rating: 4.9,
    reviews: 380,
    reviewsCount: 380,
    badge: 'Popular Bundle',
    weight: 'Essential Combo',
    category_id: 8,
    category: 'Combo',
    parent_category: 'combo',
    subcategory: 'combo',
    tags: ['combo', 'windows', 'windows-10', 'ms-office', 'office', 'deal'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Perfect for business, students, and home PCs. Includes Windows 10 Pro Retail Key + Microsoft Office 2021 Pro Plus lifetime keys with instant delivery.',
    features: [
      '1x Windows 10 Pro Retail Key',
      '1x MS Office 2021 Pro Plus Key',
      'Lifetime validity on 1 PC',
      'Instant digital delivery'
    ]
  },
  {
    id: 803,
    name: 'Windows Server 2022 + SQL Server 2022 Enterprise Combo',
    price: 3499,
    oldPrice: 15999,
    image: categoryComboImg,
    featuredImage: categoryComboImg,
    slug: 'windows-server-sql-server-combo',
    ogUrl: 'windows-server-sql-server-combo',
    rating: 5.0,
    reviews: 65,
    reviewsCount: 65,
    badge: 'Enterprise Bundle',
    weight: 'Server Combo Pack',
    category_id: 8,
    category: 'Combo',
    parent_category: 'combo',
    subcategory: 'combo',
    tags: ['combo', 'servers', 'server', 'sql-server', 'sql', 'deal'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'Complete enterprise infrastructure bundle: Windows Server 2022 Standard + Microsoft SQL Server 2022 Standard. High-performance database and virtualization solution.',
    features: [
      '1x Windows Server 2022 Standard Key',
      '1x Microsoft SQL Server 2022 Standard Key',
      'Lifetime commercial server activation',
      'Enterprise priority support'
    ]
  },
  {
    id: 804,
    name: 'Creative Master Pack: Adobe Acrobat + CorelDRAW 2024 Combo',
    price: 2199,
    oldPrice: 9999,
    image: categoryComboImg,
    featuredImage: categoryComboImg,
    slug: 'adobe-acrobat-coreldraw-combo',
    ogUrl: 'adobe-acrobat-coreldraw-combo',
    rating: 4.9,
    reviews: 110,
    reviewsCount: 110,
    badge: 'Creator Bundle',
    weight: 'Creator Pack',
    category_id: 8,
    category: 'Combo',
    parent_category: 'combo',
    subcategory: 'combo',
    tags: ['combo', 'adobe', 'coreldraw', 'others', 'design', 'deal'],
    stockStatus: 'In Stock',
    quantity: 999,
    description: 'All-in-one graphics and document production bundle. Includes Adobe Acrobat Pro DC + CorelDRAW Graphics Suite 2024 lifetime keys.',
    features: [
      '1x Adobe Acrobat Pro DC Lifetime Key',
      '1x CorelDRAW Graphics Suite 2024 Key',
      'Lifetime activation on Windows PC',
      'Instant setup guide'
    ]
  }
];
